
import React from 'react';

function GhostButton({ text, disabled, size, position, onBtnClick, extraClass }) {
  return (
    <button
      className={`c-btn c-btn--ghost ${extraClass}`}
      disabled={disabled}
      onClick={onBtnClick}
    >
      {text}
    </button>
  );
}

export default GhostButton;



// WEBPACK FOOTER //
// ./src/parts/GhostButton.js